// extracted by mini-css-extract-plugin
var _1 = "Item_author__quIi6";
var _2 = "Item_content__tVzIU";
var _3 = "Item_contentText__mP5f-";
var _4 = "Item_date__qF8Qm";
var _5 = "Item_text__ualks";
var _6 = "Item_user__XjZl-";
export { _1 as "author", _2 as "content", _3 as "contentText", _4 as "date", _5 as "text", _6 as "user" }
